import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Corporate.css';
import PolitikaPDF from '../gundogdu Döviz Kurum POLİTİKA- Aklama-Ter.Fin- Kitle İmha Silah. Yay. Fin. ile Müc..pdf';

const Corporate = () => {
  return (
    <div className="corporate">
      <Helmet>
        <title>Kurumsal | GÜNDOĞDU DÖVİZ VE ALTIN</title>
        <meta name="description" content="GÜNDOĞDU DÖVİZ VE ALTIN YETKİLİ MÜESSESE A.Ş. kurumsal bilgileri." />
        <link rel="canonical" href="https://gundogdudoviz.com/kurumsal" />
      </Helmet>

      {/* Hero Section */}
      <section className="corporate-hero">
        <div className="container">
          <div className="corporate-hero-content text-center">
            <h1 className="corporate-title">Kurumsal</h1>           
          </div>
        </div>
      </section>

      {/* Corporate Content */}
      <section className="corporate-content section-padding">
        <div className="container">
          <div className="corporate-document">
            
            <div className="corporate-section">
              <h2 className="section-title">Kurumsal Politikalarımız</h2>
              <div className="section-content">
                <p>
                  Suç Gelirlerinin Aklanması, Terörizmin Finansmanı ve Kitle İmha Silahlarının Yayılmasının Finansmanı ile Mücadelede KURUM Politikamız… 
                  <a href={PolitikaPDF} className="policy-link" target="_blank" rel="noopener noreferrer">TIKLAYINIZ</a>
                </p>
              </div>
            </div>

            <div className="corporate-section">
              <h2 className="section-title">Müşteri Tanı</h2>
              <div className="section-content">
                <p>
                  <strong>GÜNDOĞDU DÖVİZ SINIRLI YETKİLİ MÜESSESE A.Ş.</strong> olarak, 5549 sayılı Suç Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun ve ilgili mevzuat doğrultusunda, Müşterinin Tanınmasına ilişkin Esaslara uygun bir Müşteri Kabul Politikası uyguluyoruz.
                </p>
                <p>
                  Müşterinin tanınması sürecinde; kimlik tespiti için yasal düzenlemelerde belirtilen bilgi ve belgeleri alır, doğrular ve belgelerin birbiriyle tutarlı olmasını kontrol ederiz. Ayrıca müşterilerimizin şirketimizi tercih etme nedenleri, meslekleri, gelir kaynakları, iş yerleri ve faaliyet alanları hakkında gerekli bilgileri ediniriz.
                </p>
              </div>
            </div>

            <div className="corporate-section">
              <h2 className="section-title">Hesap Açılışı/İş İlişkisi</h2>
              <div className="section-content">
                <p>
                  Hesap Açılışı/İş İlişkisi Başlatmak için gerekli FORM / DÖKÜMANLAR için, irtibata geçiniz.
                </p>
                <div className="contact-info-corporate">
                  <div className="contact-item-corporate">
                    <strong>Tel:</strong> <a href="tel:+902322525390">0 232 445 75 85</a>
                  </div>
                  <div className="contact-item-corporate">
                    <strong>Email:</strong> <a href="mailto:info@gundogdudoviz.com">info@gundogdudoviz.com</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Corporate;